import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
import { useTheme } from '@mui/material';
import { TextField, Button, Alert, Snackbar, Checkbox, Dialog, DialogActions, DialogTitle, FormControl, Select, MenuItem, DialogContent, DialogContentText } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { MdSubdirectoryArrowRight, MdLockOutline } from "react-icons/md";
import { useSelector } from 'react-redux';
import { TbLoader } from 'react-icons/tb';
import BoardType1 from '../../components/BoardType1';
import mainPath from '../../utils/path';

const useStyles = makeStyles((theme) => ({

    boardLookBlock:{
        padding:'235px 0 0 0',
    
        fontFamily:[
            'Noto Sans KR'
        ],
    
        [theme.breakpoints.down(1025)]: {
            padding:'132px 0 0 0',
        },
    },
    boardListTitleBlock:{
        height:'200px',
        position:'relative'    
    },
    boardListH1:{
        fontSize:'38px',
        fontWeight:'500',
        letterSpacing: '-1.9px',
        paddingBottom:'10px',
        position:'absolute',
        top:'40%',
        left:'50%',
        transform:'translate( -50%, -50%)',    
    },
    row:{
        maxWidth:'1280px', 
        margin:'0 auto', 
        [theme.breakpoints.down(1025)]: {
            marginTop: 20,
            paddingLeft: 8,
            paddingRight: 8,
        },
    },
    boardListDiv:{
        border:'1px solid #ccc',
        background:'#fff',
        height:'80px',
        display:'flex',
        flexWrap:'wrap',
        justifyContent:'space-evenly',
        alignItems:'center',
        position:'absolute',
        top:'-40px',
        left:'0%',
        padding:'15px',
        position:'relative',
        [theme.breakpoints.down(1025)]: {
            display:'none',
        },
    },
    boardListDivM: {
        marginTop: -50,
        display:'none',
        [theme.breakpoints.down(1025)]: {
          display:'flex',
          justifyContent: 'center',
          alignItems: 'center'
        },
    },
    boardListMenuDiv:{
        color:'#555555', 
        letterSpacing: '-0.8px',
        cursor: 'pointer',   
        "&:hover": {
            color: '#007235',
        },
    },
    Titles: {
        borderTop: '2px solid #007235',
        borderBottom: '1px solid #CCCCCC',
        paddingTop: 12,
        paddingBottom: 12,
        [theme.breakpoints.down(1025)]: {
            borderBottom:'none',
        },
    },
    TitlesH1:{
        paddingLeft:'15px',
        letterSpacing: '-1.1px',
        fontSize:'18px',
    },
    secondTitles:{
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
        borderBottom:'1px solid #CCCCCC',
        padding:'5px 0',
        color:'#555555',
        letterSpacing: '-0.7px',
        fontSize:'14px',
        [theme.breakpoints.down(1025)]: {
            flexDirection: 'column',
            justifyContent:'space-around',
        },
    },
    rightDiv: {
        [theme.breakpoints.down(1025)]: {
            marginLeft: 10,
        },
    },
    rightDivModify:{
        padding:'20px 10px 0 0',
        background:'none',
        color:'#555555',
        fontFamily:[
            'Noto Sans KR'
        ],
    },
    rightDivDelete:{
        padding:'0 0 0 10px',
        borderLeft:'1px solid #CCCCCC',
        background:'none',
        color:'#555555',
        fontFamily:[
            'Noto Sans KR'
        ],
    },
    leftDivId:{
        padding:'0 10px',
    },
    leftDivHits:{
        padding:'0 10px',
        borderLeft:'1px solid #CCCCCC',
        borderRight:'1px solid #CCCCCC',
    },
    leftDivDate:{
        padding:'0 0 0 10px',
    },
    content:{
        borderBottom:'1px solid #ccc',
        padding:'10px 0 0 10px',
    },
    contentImg:{
        width: '70%',
        [theme.breakpoints.down(1025)]: {
            width:'100%'
        },
    },
    pdfDiv:{
        display:'flex',
    },
    appContentInput:{
        width:'100%',
        height: '40px',
        padding:'0 0 0 8px',
        borderRadius:'3px',
        border:'1px solid #CCCCCC',
        '&:focus-within':{
          outline:'none'
        },
      },
    fileInput:{
        display: 'inline-block',
        padding: '.5em 1em',
        height: '40px',
        fontSize: '14px',
        backgroundColor: '#fff',
        color:'#007235',
        fontWeight:'600',
        cursor: 'pointer',
        borderRadius: '0px 3px 3px 0px',
        letterSpacing: '-0.7px',
    
        [theme.breakpoints.down(376)]: {
            fontSize: '12px',
        },
    
    },
    contentDataDiv:{
        paddingTop:'10px',
    },
    writeBtnDiv:{
        padding:'10px 0 30px 0',
        display:'flex',
        justifyContent:'space-between'
    },
    comment:{
        padding:'0px 0 0 10px',
        borderTop: '2px solid #007235',
    },
    upComment:{
        display:'flex',
        justifyContent:'space-between',
        paddingBottom:'10px',

    },
    upLeft:{
        display:'flex',
        paddingTop:'20px'
    },
    replyArrow:{
        marginTop:'5px',
    },
    upRight:{
        [theme.breakpoints.down(1025)]: {
            padding:'0 0 0 10px',
        },
    },
    firstComment:{
        paddingBottom:'20px',
        borderBottom:'1px solid #ccc',
    },
    secondComment:{
        padding:'20px 0',
        borderBottom:'1px solid #ccc',
    },
    commentH1:{
        color:'#007235',
        paddingRight:'10px',
    },
    commentWrite:{
        display:'flex',
        paddingTop:'20px',
        alignItems:'center'
    },
    writeBox:{
        width:'90%',
        height:'100px',
        border:'1px solid #ccc',
        fontFamily:[
            'Noto Sans KR'
        ],
    },
    writeButton:{
        height:'100px',
        width:'10%',
        background:'#555',
        color:'#fff',
        fontFamily:[
            'Noto Sans KR'
        ],
    },

    load:{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
      },
      loadingIcon:{
        color:'#007235',
        fontSize:'50px',
        animation:'$loadSpin 5s infinite'
      },
      "@keyframes loadSpin":{
        from: { transform:'rotate(0deg)' },
        to: { transform:'rotate(1turn)' }
      },

}));


const BoardLook = () => {
    let navigate = useNavigate();
    const location = useLocation();
    const userInfo = useSelector(state => state.user.userInfo);
    const theme = useTheme(); 
    const classes = useStyles(theme);

    const [content, setContent] = useState();
    const [comments, setComments] = useState([]);
    const [files, setFiles] = useState([]);

    const [errSnack, setErrSnack] = useState(false);
    const [succSnack, setSuccSnack] = useState(false);
    const [commentText, setCommentText] = useState('')
    const [commentSecr, setCommentSec] = useState('')
    const [coCommentText, setCoCommentText] = useState('')
    const [coCommentSecr, setCoCommentSecr] = useState('')
    const [cmtWrId, setCmtWrId] = useState(0);

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const [dialog, setDialog] = useState('');

    const [menuVal, setMenuVal] = useState('');

    const [delDial, setDelDial] = useState(false)
    const [delDialComm, setDelDialComm] = useState(false)
    const [delDialCo, setDelDialCo] = useState({})

    const login = useSelector(state => state.user.login);

    useEffect(() => {
        if(!login){
          navigate("/Login");
        }
    
      }, [login])


    const BoardList = [
        {name:'qanda', text:'질문과 답변'},
        {name:'notice', text:'공지사항'},
        {name:'after', text:'사용후기'},
        {name:'fag', text:'자주하는 질문'}
    ]

    const getLookItems = async() => {
        try{
            const res = await axios.post('/api/board/boardItem/', {boardType: location.state.cateType  , boardItem : location.state.id})
            if (res.data.success === false) {
                alert('게시판 불러오기 실패')
                return
            }

            setContent(res.data.content)
            setComments(res.data.comments)
            setFiles(res.data.files)

        } catch (e) {
            console.log(e)
        }
    }

    useEffect( () => {
        setMenuVal(BoardList.find(itm => itm.name === location.state.cateType).text)
        if (location.state.cateType && location.state.id ) {
            getLookItems()
        }
        
    }, [location.state.cateType, location.state.id])

    const getCartItems = async() => {
        try {
          setLoading(true)
          const res = await axios.get(`/api/board/boardList/${location.state.cateType}`)
          if (res.data.success === false) {
            setDialog('게시판 불러오기 실패')
            setLoading(false)
            return
          }
          setData(res.data.result)
          setLoading(false)
      
        } catch (e) {
          console.log(e)
          setLoading(false)
        }
      }
    
      useEffect(() => {
        if (location.state.cateType) {
          getCartItems()
        }
      } , [location.state.cateType])

    const boardDelete = async() => {
        try{
            const resDel = await axios.post('/api/board/delBoardItem/', {boardType: location.state.cateType, wr_id: content['wr_id'] , wr_file: content['wr_file'] })

            if (!resDel.data.success) {
                setDialog('글삭제를 실패하였습니다.')
                return
            }

            navigate('/BoardList', {
                state:{cateType: location.state.cateType}
              })
            
        } catch (e) {
            console.log(e)
        }
    }


    const fileDown = async(fileurl) => {
        try {
          const res = await axios.post(
            '/api/board/boardFileDownload/',
            {
                boardType: location.state.cateType,
                url: fileurl
            },
            {
              responseType: 'blob',
            }
            )
    
          setSuccSnack(true)
    
          const name = res.headers["content-disposition"].split("filename=")[1].replace(/"/g, "");
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
    
          link.href = url;
          link.setAttribute("download", name);
          link.style.cssText = "display:none";
          document.body.appendChild(link);
          link.click();
          link.remove();
    
    
        } catch (e) {
          setErrSnack(true)
          console.log(e)
        }
    }
    
    const deleteCmt = async(id, cmtReply, parent, cmt) => {
        try{
            const resDel = await axios.post('/api/board/deleteComment/', 
                                {
                                    boardType: location.state.cateType, 
                                    wr_id: id, 
                                    wr_comment_reply: cmtReply, 
                                    wr_parent: parent,
                                    wr_comment: cmt,
                                    wr_id_main: content['wr_id']
                                }
            )

            if (!resDel.data.success) {
                setDialog('글삭제를 실패하였습니다.')
                return
            }

            getLookItems()
            setDelDialComm(false)
        } catch (e) {
            console.log(e)
        }
    }

    const addCmt = async() => {
        if (commentText === '') return setDialog('댓글을 입력해주세요!')
        let ip = ''

        // try {
        //   const response = await axios.get('https://api.ipify.org?format=json');
        //   ip = response.data.ip;
        // }catch (error) {
        //   console.error(error);
        //   return
        // }

        try{
            const resDel = await axios.post('/api/board/writeComment/', 
                                {
                                    boardType: location.state.cateType, 
                                    wr_id: content['wr_id'], 
                                    wr_num: content['wr_num'], 
                                    wr_reply: content['wr_reply'], 
                                    wr_comment: 0, 
                                    wr_option: commentSecr, 
                                    wr_content: commentText, 
                                    mb_id: userInfo['mb_id'], 
                                    wr_name: userInfo['mb_name'], 
                                    wr_email: userInfo['mb_email'], 
                                    wr_ip: ip
                                }
            )

            if (!resDel.data.success) {
                setDialog('댓글 추가를 실패하였습니다.')
                return
            }

            getLookItems()
            setCommentText('')
            setCommentSec('')
            
        } catch (e) {
            console.log(e)
        }
    }

    const addCoCmt = async(comment) => {
        if (coCommentText === '') return setDialog('댓글을 입력해주세요!')
        let ip = ''

        // try {
        //   const response = await axios.get('https://api.ipify.org?format=json');
        //   ip = response.data.ip;
        // }catch (error) {
        //   console.error(error);
        //   return
        // }

        try{
            const resDel = await axios.post('/api/board/writeComment/', 
                                {
                                    boardType: location.state.cateType, 
                                    wr_id: content['wr_id'], 
                                    wr_num: content['wr_num'], 
                                    wr_reply: content['wr_reply'], 
                                    wr_comment: comment, 
                                    wr_option: coCommentSecr, 
                                    wr_content: coCommentText, 
                                    mb_id: userInfo['mb_id'], 
                                    wr_name: userInfo['mb_name'], 
                                    wr_email: userInfo['mb_email'], 
                                    wr_ip: ip
                                }
            )

            if (!resDel.data.success) {
                setDialog('댓글 추가를 실패하였습니다.')
                return
            }

            getLookItems()
            setCoCommentText('')
            setCoCommentSecr('')
            setCmtWrId(0)
            
        } catch (e) {
            console.log(e)
        }
    }



    const snackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
    
        setErrSnack(false);
        setSuccSnack(false)
    };

    useEffect(() => {

        return () => {
            setContent()
            setComments([])
            setFiles([])
            setData([])
        }
    }, [])

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 48 * 4.5 + 8,
                width: 250,
            },
        },
    };

    return(
        <div className={classes.boardLookBlock}>
            <div 
                className={classes.boardListTitleBlock} 
                style={{ backgroundImage:'url(/images/BoardList_banner.png)'}}
            >
                <h1 className={classes.boardListH1}>
                {location.state.cateType && BoardList.find((item) => location.state.cateType === item.name).text}
                </h1>
            </div>
            <div className={classes.row}>
                <div className={classes.boardListDiv}>
                    { BoardList.map( (boardmenu, index) => (
                    <div 
                        key={index} 
                        className={classes.boardListMenuDiv}
                        onClick={() => { 
                            navigate("/BoardList", {
                                state: { cateType: boardmenu.name }
                            });
                        }}
                    >
                        {boardmenu.text}
                    </div>
                    ))}
                </div>
                <div className={classes.boardListDivM}>
                    <FormControl sx={{ m: 1, width: 300, backgroundColor: '#fff', boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',}}>
                    <Select
                        value={menuVal}
                        onChange={(e) => setMenuVal(e.target.value)}
                        inputProps={{ 
                            'aria-label': 'Without label' ,
                        }}
                        MenuProps={MenuProps}
                        sx={{
                            backgroundColor: '#fff',
                            height: 50,
                            textAlign: 'center',
                            '.MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                            },
                        }}
                    >      
                        {BoardList.map((itm, idx) => (
                        <MenuItem
                            key={idx} 
                            onClick={() => { 
                            navigate("/BoardList", {
                                state: { cateType: itm.name }
                            });
                            }}
                            value={itm.text}
                        >
                            {itm.text}
                        </MenuItem>
                        ))}

                        
                    </Select>
                    </FormControl>
                </div>

            </div>
            
            <div className={classes.row}>
                <div className={classes.boardBoxDiv}>
                    <div className={classes.Titles}>
                        <h1 className={classes.TitlesH1}>
                            {content && content['wr_subject']}
                        </h1>
                    </div>
                    <div className={classes.secondTitles}>
                        <div className={classes.leftDiv}>
                            <span className={classes.leftDivId}>{location.state.id}</span>
                            <span className={classes.leftDivHits}>
                                조회수: {content && content['wr_hit'] + 1}
                            </span>
                            <span className={classes.leftDivDate}>
                                {content && content['mb_id']}  ({content && content['mb_region']}/{content && content['mb_storename']}) {content && content['wr_datetime'].substr(0, 10)}
                            </span>
                        </div>

                        <div className={classes.rightDiv}>
                            {userInfo && content && (userInfo['mb_id'] === content['mb_id'] || userInfo['mb_level'] === 10) && (
                                <>
                                    <button 
                                        className={classes.rightDivModify}
                                        onClick={() => { 
                                            if(userInfo['mb_level'] !== 10 && content['wr_comment'] !== 0) return setDialog('댓글이 있는 글은 수정이 불가능 합니다.')
                                            navigate("/BoardUpdate", {
                                                state: { 
                                                    cateType: location.state.cateType,
                                                    wrId: content['wr_id']
                                                }
                                              });
                                        }}
                                    >
                                        수정
                                    </button> 
                                    <button 
                                        className={classes.rightDivDelete}
                                        onClick={() => setDelDial(true)}
                                    >
                                        삭제
                                    </button>                    
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <div className={classes.content}>
                    
                    <div>
                        {files.length > 0 && files.map((item, idx) => {
                            if (item['bf_type'] === 0) return
                            return(
                            <img 
                                src={`${mainPath}/media/data/file/${location.state.cateType}/${item['bf_file']}`}
                                className={classes.contentImg}
                                key={idx}
                            />
                            )
                        })}

                    </div>
                    <div className={classes.contentDataDiv}>
                        <TextField 
                            value={content && content['wr_content']}
                            multiline
                            variant="standard"
                            fullWidth
                            color='secondary'
                            inputProps={
                                { readOnly: true, }
                            }
                        />
                        {files.length > 0 && files.filter((item) => item['bf_type'] === 0).map((itm) => (
                            <Button
                                key={itm['bf_no']}        
                                variant="outlined"
                                onClick={() => fileDown(itm['bf_file'])}
                                style={{ margin:'10px'}}
                            >
                                {itm['bf_source']} 다운로드
                            </Button>
                        ))}
                        {content && content['wr_link1'] !== '' && (
                            <a href={content['wr_link1']}>{content['wr_link1']}</a>
                        )}
                    </div>
                </div>
                <div className={classes.writeBtnDiv}>
                    <Button 
                        variant="contained"
                        style={{
                            background:'#007235',
                            padding:'5px 20px',
                            borderRadius:'0'
                        }}
                        onClick={() => { 
                            navigate("/BoardList", {
                                state: { cateType: location.state.cateType }
                              });
                        }}
                    >
                        목록
                    </Button>
                    {
                        userInfo['mb_level'] === 10 && (
                        <Button 
                            variant="contained"
                            style={{
                                background:'#007235',
                                padding:'5px 20px',
                                borderRadius:'0'
                            }}
                            onClick={ () => {
                                navigate("/BoardWrite", {
                                    state: 
                                    { 
                                        cateType: location.state.cateType, 
                                        wrReply:'A', subject: content['wr_subject'], 
                                        wrNum: content['wr_num']
                                    }
                                })
                            }}
                        >
                            답글
                        </Button>
                        )
                    }

                </div>
                
                {/* 댓글 */}
                <div className={classes.comment}>
                    {comments.length > 0 ? comments.map((itm, idx) => 
                    (   
                        <div key={idx}>
                        <div className={classes.firstComment}>
                            <div className={classes.upComment}>
                                <div className={classes.upLeft}>
                                    {itm['wr_comment_reply'] === "A" && (
                                        <MdSubdirectoryArrowRight className={classes.replyArrow} />
                                    )}
                                    <h1 className={classes.commentH1}>
                                        {itm['wr_name']}
                                    </h1>
                                    <span>
                                        {itm['wr_datetime'].replace('T', ' ').substr(0, 16)}
                                    </span>
                                </div>
                                <div className={classes.upRight}>
                                    <button 
                                        className={classes.rightDivModify}
                                        onClick={() => {
                                            if(itm['wr_id'] === cmtWrId) return setCmtWrId('')

                                            setCoCommentText('')
                                            setCmtWrId(itm['wr_id'])
                                        }}
                                    >
                                        댓글
                                    </button> 
                                    {
                                        (userInfo['mb_id'] === itm['mb_id'] || userInfo['mb_level'] === 10) && (
                                            <button 
                                                className={classes.rightDivDelete}
                                                onClick={() => {
                                                    setDelDialCo({wrId: itm['wr_id'], wrCommentReply: itm['wr_comment_reply'], wrParent: itm['wr_parent'], wrComment: itm['wr_comment']})
                                                    setDelDialComm(true)
                                                }}
                                            >
                                                삭제
                                            </button>
                                        )
                                    }
                                </div>
                            </div>
                            <div className={classes.downComment}>
                                <span>
                                    {itm['wr_option'] !== 'secret' ? itm['wr_content'] :
                                        (userInfo['mb_id'] === itm['mb_id'] || userInfo['mb_level'] === 10) ? 
                                            itm['wr_content'] :
                                        <div>
                                            <MdLockOutline size="20" /> 비밀글 입니다.
                                        </div> 
                                    }
                                </span>
                            </div>
                        </div>
                        {itm['wr_id'] === cmtWrId && (
                                            <div className={classes.commentWrite}>
                                                <MdLockOutline size="20" />
                                                <Checkbox
                                                    checked={coCommentSecr === 'secret' ? true : false}
                                                    onChange={() => {
                                                        coCommentSecr === 'secret' ?
                                                        setCoCommentSecr('') :
                                                        setCoCommentSecr('secret')
                                                    }}
                                                />
                                                <textarea 
                                                    className={classes.writeBox}
                                                    value={coCommentText}
                                                    onChange={ (e) => {setCoCommentText(e.target.value)}}
                                                >
                        
                                                </textarea>
                                                <button 
                                                    className={classes.writeButton}
                                                    onClick={() => addCoCmt(itm['wr_comment'])}
                                                >
                                                    댓글작성
                                                </button>
                                            </div>
                        )}
                        </div>
                    )): (
                        <div>댓글이 없습니다.</div>
                    )}


                    <div className={classes.commentWrite}>
                        <MdLockOutline size="15" />
                        <Checkbox
                            checked={commentSecr === 'secret' ? true : false}
                            onChange={() => {
                                commentSecr === 'secret' ?
                                setCommentSec('') :
                                setCommentSec('secret')
                            }}
                        />
                        <textarea 
                            className={classes.writeBox}
                            value={commentText}
                            onChange={ (e) => {setCommentText(e.target.value)}}
                        >

                        </textarea>
                        <button 
                            className={classes.writeButton}
                            onClick={() => addCmt()}
                        >
                            댓글작성
                        </button>
                    </div>
                </div>
            </div>


            <div>
                {loading ?             
                    <div className={classes.load}>
                    <TbLoader className={classes.loadingIcon}/>
                    </div>
                    : (
                    <BoardType1 
                        data={data} 
                        cateType={location.state.cateType} 
                    />
                    )         
                }
            </div>

            

            <Snackbar 
                open={errSnack} 
                autoHideDuration={6000} 
                onClose={snackClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
            >
                <Alert severity="error">수행을 실패 하였습니다!</Alert>
            </Snackbar>
            <Snackbar 
                open={succSnack} 
                autoHideDuration={6000} 
                onClose={snackClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
            >
                <Alert severity="success">수행을 성공 하였습니다!</Alert>
            </Snackbar> 

            <Dialog
                open={dialog === '' ? false : true}
                onClose={() => setDialog('')}
            >
                <DialogTitle id="alert-dialog-title">
                    {dialog}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={() => setDialog('')} autoFocus>
                        확인
                    </Button>
                </DialogActions>
            </Dialog>
            
            <Dialog
                open={delDial}
                onClose={() => setDelDial(false)}
            >
                <DialogContent>
                    <DialogContentText>
                        정말 게시글을 삭제 하시겠습니까?
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={() => setDelDial(false)}>아니오</Button>
                    <Button onClick={() => boardDelete()}>네</Button>
                </DialogActions>
            </Dialog>      

            <Dialog
                open={delDialComm}
                onClose={() => {
                    setDelDialComm(false)
                    setDelDialCo({})
                }}
            >
                <DialogContent>
                    <DialogContentText>
                        정말 댓글을 삭제 하시겠습니까?
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button 
                        onClick={() => {
                            setDelDialComm(false)
                            setDelDialCo({})
                        }}
                    >
                        아니오
                    </Button>
                    <Button onClick={() => deleteCmt(delDialCo.wrId, delDialCo.wrCommentReply, delDialCo.wrParent, delDialCo.wrComment)}>네</Button>
                </DialogActions>
            </Dialog>      

        </div>
    )
}

export default BoardLook